/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { useEffect, useState } from 'react'
import {
    HeartIcon,
    BookmarkIcon,
    ShareIcon,
} from "@heroicons/react/24/solid";
import { toast } from 'react-toastify';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { useTranslation } from 'react-i18next';

// @store
import { useSpinnerStore } from '../../../store/useSpinnerStore';
import usePostStore from '../../../store/usePostStore';

// @types
import { Post } from '../../../types/post.types';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

// @services
import profileService from "../../../services/profile.service";
import { useMediaQuery } from 'react-responsive';

const MarketplaceView: React.FC<{ professionalId: string, setPageSelected: Function }> = ({ professionalId, setPageSelected }) => {
    const { t } = useTranslation();
    const { openSpinner } = useSpinnerStore();
    const isMobile = useMediaQuery({ query: "(max-width: 1024px)" });
    const { getPostsByProfessional } = usePostStore();
    const [listPost, setListPost] = useState<Post[]>([]);
    const [galleryReels, setGalleryReels] = useState<{ id: string, value: Blob }[]>([]);

    const getListPosts = async () => {
        openSpinner(true);
        try {
            if (!professionalId) return;
            const response = await getPostsByProfessional(professionalId);
            response?.map((item: Post) => getLogoByPost(item?.postId))
            setListPost(response);
            openSpinner(false);
        } catch (error) {
            openSpinner(false);
            toast.error(t("error.callList"));
        }
    }

    const getLogoByPost = async (postId: string) => {
        if (!postId) return;
        openSpinner(true);
        try {
            await profileService.getLogoByPost(postId ?? '').then((response: any) => {
                const list = galleryReels;
                list.push({ id: postId, value: response });
                return setGalleryReels(list);
            })
            openSpinner(false);
        } catch (error) {
            openSpinner(false);
            toast.error(t("error.callList"));
        }
    }

    useEffect(() => {
        getListPosts();
    }, [])

    const getImage = (post: string) => {
        const image = galleryReels?.find((item: any) => item?.id === post);
        if (!image) return "";
        const renderImage = URL.createObjectURL(image.value);
        return renderImage;
    }

    return (
        <div className='w-full flex justify-center mt-[10px] '>
            {listPost?.length
                ? <div className='w-full '>
                    <Swiper
                        spaceBetween={"10px"}
                        slidesPerView={isMobile ? 1 : 2}
                        navigation={true}
                        modules={[Navigation]}
                        className="mySwiper"
                    >
                        {listPost.map((reel: Post) => (
                            <SwiperSlide>
                                <div className="flex items-center p-4 h-[80vh] ">
                                    <div className="w-[280px] h-[500px] max-h-[600px] mx-auto">
                                        <div className="relative w-full h-full bg-white dark:bg-dark-cBackground">
                                            <>
                                                {galleryReels?.length
                                                    ? <img
                                                        src={getImage(reel?.postId)}
                                                        alt="Preview"
                                                        onError={(e: any) => (e.target.src = '/assets/img/no-image.png')}
                                                        className="w-full h-full object-cover rounded-sm"
                                                    />
                                                    : <img
                                                        src={'/assets/img/no-image.png'}
                                                        alt={"Deefault background"}
                                                        className="rounded-lg cover h-full w-full"
                                                    />
                                                }

                                                {/* Interaction buttons column */}
                                                <div className="absolute bottom-10 left-4 flex items-end gap-4">
                                                    <div className='flex flex-col items-center gap-4'>
                                                        <div className="flex flex-col items-center">
                                                            <button className="hover:scale-110 transition-transform">
                                                                <HeartIcon className="h-7 w-7 text-[#F97068]" />
                                                            </button>
                                                            <span className="text-white text-xs">0</span>
                                                        </div>
                                                        <div className="flex flex-col items-center">
                                                            <button className="hover:scale-110 transition-transform">
                                                                <BookmarkIcon className="h-7 w-7 text-white" />
                                                            </button>
                                                            <span className="text-white text-xs">0</span>
                                                        </div>
                                                        <div className="flex flex-col items-center">
                                                            <button className="hover:scale-110 transition-transform">
                                                                <ShareIcon className="h-7 w-7 text-white" />
                                                            </button>
                                                            <span className="text-white text-xs">0</span>
                                                        </div>
                                                    </div>

                                                    <div className="p-4">
                                                        <h4 className="text-white font-semibold">{reel.title}</h4>
                                                        <p className="text-white text-sm mt-1">{reel.description}</p>
                                                        <p className="text-white/80 text-sm mt-2 font-medium">
                                                            {reel.hashtags}
                                                        </p>
                                                        <button
                                                            onClick={() => setPageSelected(1)}
                                                            className="mt-2 px-[8px] py-[5px] bg-red-500 text-white rounded-lg hover:bg-red-600 transition text-[12px]"
                                                        >
                                                            {t('requestsAndProposals.details.returnToProposal')}
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                : <p className='flex text-[16px] text-gray-400 dark:text-white text-center pl-[20%] pr-[20%] mt-[10vh]'>
                    {t("requestsAndProposals.details.withoutReels")}
                </p>
            }
        </div>
    )
}

export default MarketplaceView